import { storeSelf } from "@fdn/profile_store";
import { selfApi } from "@fdn/rtk_profile_store";
import { combineReducers } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";
import storeAddress from "../address_store/lib/store";
import storeAppliedPromotion from "../applied_promotion_store/lib/store";
import storeBanner from "../banner_store/lib/store";
import storeBrands from "../brands_store/lib/store";
import storeCartBadgeCount from "../cart_badge_count_store/lib/store";
import storeCartTotals from "../cart_total_store/lib/store";
import storeCategoryDesktop from "../category_desktop_store/lib/store";
import storeCategoryDetail from "../category_detail_store/lib/store";
import storeCategory from "../category_store/lib/store";
import storeCheckFlashSalePDP from "../checkflashsalepdp_store/lib/store";
import storeCheckStock from "../checkstock_store/lib/store";
import storeDeletePromotion from "../delete_promotion_store/lib/store";
import storeFlashSale from "../flash_sale_store/lib/store";
import storeHomepage from "../homepage_store/lib/store";
import storeLoginPopup from "../login_popup_store/lib/store";
import storeMergeCart from "../merge_cart_store/lib/store";
import storeMyOrders from "../my_orders_store/lib/store";
import storeModalPopup from "../popup_modal_verify/lib/store";
import storeProductDetail from "../product_detail_store/lib/store";
import storeProducts from "../products_store/lib/store";
import storePromotionsBrowse from "../promotion_browse_store/lib/store";
import storePromotionDetail from "../promotion_detail_store/lib/store";
import storePromotions from "../promotion_store/lib/store";
import { apiSlice } from "../rtk-query/feature/api/apiSlice";
import { addressApiSlice } from "../rtk-query/feature/service/addressApiSlice";
import { bannerApiSlice } from "../rtk-query/feature/service/bannerApiSlice";
import { brandsApiSlice } from "../rtk-query/feature/service/brandApiSlice";
import { cartApiSlice } from "../rtk-query/feature/service/cartApiSlice";
import { categoryApiSlice } from "../rtk-query/feature/service/categoryApiSlice";
import { homeApiSlice } from "../rtk-query/feature/service/homeApiSlice";
import { notificationApiSlice } from "../rtk-query/feature/service/notificationApiSlice";
import { orderApiSlice } from "../rtk-query/feature/service/orderApiSlice";
import { orderDetailApiSlice } from "../rtk-query/feature/service/orderDetailApiSlice";
import { paymentApiSlice } from "../rtk-query/feature/service/paymentApiSlice";
import { productApiSlice } from "../rtk-query/feature/service/productApiSlice";
import { profileApiSlice } from "../rtk-query/feature/service/profileApiSlice";
import { promoApiSlice } from "../rtk-query/feature/service/promoApiSlice";
import { searchApiSlice } from "../rtk-query/feature/service/searchApiSlice";
import { shippingAPiSlice } from "../rtk-query/feature/service/shippingApiSlice";
import storeSimilarProduct from "../similar_product_store/lib/store";
import storeWishlist from "../wishlist_store/lib/store";

const rootReducer = combineReducers({
	storeProductDetail,
	storeSelf,
	storeCategory,
	storeCategoryDesktop,
	storeProducts,
	storeBrands,
	storeFlashSale,
	storePromotions,
	storePromotionDetail,
	storePromotionsBrowse,
	storeBanner,
	storeAddress,
	storeWishlist,
	storeSimilarProduct,
	storeCartBadgeCount,
	storeCheckStock,
	storeCategoryDetail,
	storeAppliedPromotion,
	storeHomepage,
	storeDeletePromotion,
	storeMergeCart,
	storeMyOrders,
	storeCartTotals,
	storeCheckFlashSalePDP,
	storeLoginPopup,
	storeModalPopup,
	[apiSlice.reducerPath]: apiSlice.reducer,
	[profileApiSlice.reducerPath]: profileApiSlice.reducer,
	[cartApiSlice.reducerPath]: cartApiSlice.reducer,
	[productApiSlice.reducerPath]: productApiSlice.reducer,
	[categoryApiSlice.reducerPath]: categoryApiSlice.reducer,
	[brandsApiSlice.reducerPath]: brandsApiSlice.reducer,
	[selfApi.reducerPath]: selfApi.reducer,
	[bannerApiSlice.reducerPath]: bannerApiSlice.reducer,
	[searchApiSlice.reducerPath]: searchApiSlice.reducer,
	[homeApiSlice.reducerPath]: homeApiSlice.reducer,
	[addressApiSlice.reducerPath]: addressApiSlice.reducer,
	[paymentApiSlice.reducerPath]: paymentApiSlice.reducer,
	[promoApiSlice.reducerPath]: promoApiSlice.reducer,
	[shippingAPiSlice.reducerPath]: shippingAPiSlice.reducer,
	[orderApiSlice.reducerPath]: orderApiSlice.reducer,
	[orderDetailApiSlice.reducerPath]: orderDetailApiSlice.reducer,
	[notificationApiSlice.reducerPath]: notificationApiSlice.reducer,
});

const masterReducer = (state, action) => {

	if (action.type === HYDRATE) {

		// Gabungkan state lama dan state dari server
		const nextState = {
			...state, // State lama
			...action.payload, // State dari server
			api: {
				...state.api,
				...action.payload.api,
				queries: {
					...state.api.queries,
					// Hanya replace key baru dari queries payload
					...Object.keys(action.payload.api?.queries || {})
						.reduce((acc, key) => {

							acc[key] = action.payload.api.queries[key];
							return acc;

						}, {}),
				},
				provided: {
					...state.api.provided,
					// Hanya replace key baru dari provided payload
					...Object.keys(action.payload.api?.provided || {})
						.reduce((acc, key) => {

							acc[key] = action.payload.api.provided[key];
							return acc;

						}, {}),
				},
				subscriptions: {
					...state.api.subscriptions,
					// Hanya replace key baru dari subscriptions payload
					...Object.keys(action.payload.api?.subscriptions || {})
						.reduce((acc, key) => {

							acc[key] = action.payload.api.subscriptions[key];
							return acc;

						}, {}),
				},
				config: {
					...state.api.config,
					// Hanya replace key baru dari config payload
					...Object.keys(action.payload.api?.config || {})
						.reduce((acc, key) => {

							acc[key] = action.payload.api.config[key];
							return acc;

						}, {}),
				},
			},
			selfApi: {
				...state.selfApi,
				...action.payload.selfApi,
				queries: {
					...state.selfApi.queries,
					// Hanya replace key baru dari queries payload
					...Object.keys(action.payload.selfApi?.queries || {})
						.reduce((acc, key) => {

							acc[key] = action.payload.selfApi.queries[key];
							return acc;

						}, {}),
				},
				provided: {
					...state.selfApi.provided,
					// Hanya replace key baru dari provided payload
					...Object.keys(action.payload.selfApi?.provided || {})
						.reduce((acc, key) => {

							acc[key] = action.payload.selfApi.provided[key];
							return acc;

						}, {}),
				},
				subscriptions: {
					...state.selfApi.subscriptions,
					// Hanya replace key baru dari subscriptions payload
					...Object.keys(action.payload.selfApi?.subscriptions || {})
						.reduce((acc, key) => {

							acc[key] = action.payload.selfApi.subscriptions[key];
							return acc;

						}, {}),
				},
				config: {
					...state.selfApi.config,
					// Hanya replace key baru dari config payload
					...Object.keys(action.payload.selfApi?.config || {})
						.reduce((acc, key) => {

							acc[key] = action.payload.selfApi.config[key];
							return acc;

						}, {}),
				},
			},
		};

		// Prioritaskan state client jika ada konflik
		if (state[apiSlice.reducerPath]?.queries) {

			nextState[apiSlice.reducerPath] = {
				...state[apiSlice.reducerPath],
				...action.payload[apiSlice.reducerPath],
				queries: {
					...state[apiSlice.reducerPath]?.queries,
					// Hanya replace key baru di queries
					...Object.keys(action.payload[apiSlice.reducerPath]?.queries || {})
						.reduce((acc, key) => {

							acc[key] = action.payload[apiSlice.reducerPath].queries[key];
							return acc;

						}, {}),
				},
				provided: {
					...state[apiSlice.reducerPath]?.provided,
					// Hanya replace key baru di provided
					...Object.keys(action.payload[apiSlice.reducerPath]?.provided || {})
						.reduce((acc, key) => {

							acc[key] = action.payload[apiSlice.reducerPath].provided[key];
							return acc;

						}, {}),
				},
				subscriptions: {
					...state[apiSlice.reducerPath]?.subscriptions,
					// Hanya replace key baru di subscriptions
					...Object.keys(action.payload[apiSlice.reducerPath]?.subscriptions || {})
						.reduce((acc, key) => {

							acc[key] = action.payload[apiSlice.reducerPath].subscriptions[key];
							return acc;

						}, {}),
				},
				config: {
					...state[apiSlice.reducerPath]?.config,
					// Hanya replace key baru di config
					...Object.keys(action.payload[apiSlice.reducerPath]?.config || {})
						.reduce((acc, key) => {

							acc[key] = action.payload[apiSlice.reducerPath].config[key];
							return acc;

						}, {}),
				},
			};

		}

		if (state[selfApi.reducerPath]?.queries) {

			nextState[selfApi.reducerPath] = {
				...state[selfApi.reducerPath],
				...action.payload[selfApi.reducerPath],
				queries: {
					...state[selfApi.reducerPath]?.queries,
					// Hanya replace key baru di queries
					...Object.keys(action.payload[selfApi.reducerPath]?.queries || {})
						.reduce((acc, key) => {

							acc[key] = action.payload[selfApi.reducerPath].queries[key];
							return acc;

						}, {}),
				},
				provided: {
					...state[selfApi.reducerPath]?.provided,
					// Hanya replace key baru di provided
					...Object.keys(action.payload[selfApi.reducerPath]?.provided || {})
						.reduce((acc, key) => {

							acc[key] = action.payload[selfApi.reducerPath].provided[key];
							return acc;

						}, {}),
				},
				subscriptions: {
					...state[selfApi.reducerPath]?.subscriptions,
					// Hanya replace key baru di subscriptions
					...Object.keys(action.payload[selfApi.reducerPath]?.subscriptions || {})
						.reduce((acc, key) => {

							acc[key] = action.payload[selfApi.reducerPath].subscriptions[key];
							return acc;

						}, {}),
				},
				config: {
					...state[selfApi.reducerPath]?.config,
					// Hanya replace key baru di config
					...Object.keys(action.payload[selfApi.reducerPath]?.config || {})
						.reduce((acc, key) => {

							acc[key] = action.payload[selfApi.reducerPath].config[key];
							return acc;

						}, {}),
				},
			};

		}

		return nextState;

	}

	return rootReducer(state, action);

};

export default masterReducer;
